import appKeyActionTypes from "./appKeyActionTypes";

export const saveAppKeys = (keys) => ({
  type: appKeyActionTypes.SAVE_KEY,
  payload: keys,
});

export const saveLoginUrl = (url) => ({
  type: appKeyActionTypes.SAVE_LOGIN_URL,
  payload: url,
});

export const saveBaseUrl = (url) => ({
  type: appKeyActionTypes.SAVE_BASE_URL,
  payload: url,
});

export const getAccountConfigStart = (request) => ({
  type: appKeyActionTypes.GET_ACCOUNT_CONFIG_START,
  payload: request,
});

export const saveAccountLang = (lang) => ({
  type: appKeyActionTypes.SAVE_ACCOUNT_LANG,
  payload: lang,
});

export const getUserRights = (request) => ({
  type: appKeyActionTypes.GET_USER_RIGHTS_START,
  payload: request,
});

export const getUserLangs = (request) => ({
  type: appKeyActionTypes.GET_USER_LANG_START,
  payload: request,
});

export const getSessionUser = (request) => ({
  type: appKeyActionTypes.GET_SESSION_USER_START,
  payload: request,
});

export const getFranchiseInfo = (request) => ({
  type: appKeyActionTypes.GET_FRANCHAISE_START,
  payload: request,
});
